import { toast } from "react-toastify";
import { instanceAxiosPrivate } from "../../axios";
import {
  setCasosUsuario,
  setLoadingHD,
  setCasosReporte,
  setIsAdmin,
  setAdmin,
  setDetallesCaso,
  setOrganizaciones,
  setDependencias,
  setMatchGA,
  setTypeMsj,
  updFormInfo,
  setPrioridad,
  setUserReasignacionCaso,
  setCasoNivelesSelecionado,
} from "./helpdeskSlice";

export const getUserSolicitudes = (e) => {
  return async (dispatch, getState) => {
    const { fini, ffin } = getState().helpdesk;
    const { perfil } = getState().user;

    const xhr = new instanceAxiosPrivate();
    if (perfil.user_id !== null) {
      const { data } = await xhr.services.get("/v1/helpdesk/usercase", {
        params: {
          fecha_ini: fini + " 00:00:00" || e.fechaini + " 00:00:00",
          fecha_fin: ffin + " 23:59:59" || e.fechafin + " 23:59:59",
          user_id: perfil.user_id,
        },
      });
      dispatch(setCasosUsuario(data));
    }
  };
};
export const getAdminSolicitudes = (e) => {
  return async (dispatch, getState) => {
      const { perfil } = getState().user;
      const xhr = new instanceAxiosPrivate();
      const { data } = await xhr.services.get(
        "/v1/helpdesk/gethd2useradministrator",
        {
          params: { user_id: perfil.user_id },
        }
      );
      if (Object.keys(data).length > 0) {
        dispatch(setAdmin(data));
        dispatch(setIsAdmin(true));
      }
  };
};


export const getReporteSolicitudes = (e) => {
  return async (dispatch, getState) => {
      const { fini, ffin } = getState().helpdesk;
      const { perfil } = getState().user;

      let idAreaUsuario, organizaciones;      
      let solicitudes_por_usuario = [];
      let solicitudes_por_admin = [];

      const xhr = new instanceAxiosPrivate();
      //tipo de usuario
      const { data: typeuser } = await xhr.services.get(
        "/v1/helpdesk/gethd2typeuser",
        {
          params: { user_id: perfil.user_id },
        }
      );
      // area usuario
      const { data: userarea } = await xhr.services.get(
        "/v1/helpdesk/getareabyuser",
        {
          params: { user_id: perfil.user_id },
        }
      );
      const tipoUsuario = Object.assign({}, ...typeuser);

      idAreaUsuario = tipoUsuario.id_area || userarea.id_area;
      //organizaciones 
      const { data: organizacionesDB } = await xhr.services.get("/v1/helpdesk/getorganizacion");
      organizaciones = organizacionesDB

      

      const { data: admin } = await xhr.services.get(
        "/v1/helpdesk/gethd2useradministrator",
        {
          params: { user_id: perfil.user_id },
        }
      );

      //casos por area
      if (Object.keys(admin).length > 0) {
        const { data: areacaseadm } = await xhr.services.get(
          "/v1/helpdesk/areacase",
          {
            params: {
              fecha_ini: fini + " 00:00:00" || e.fechaini + " 00:00:00",
              fecha_fin: ffin + " 23:59:59" || e.fechafin + " 23:59:59", 
              user_id: perfil.user_id,
              id_area: idAreaUsuario,
            },
          }
        );
        solicitudes_por_admin = areacaseadm;
      } else {
        const { data: rpcase } = await xhr.services.get("/v1/helpdesk/rpcase", {
          params: {
            fecha_ini: fini + " 00:00:00" || e.fechaini + " 00:00:00",
            fecha_fin: ffin + " 23:59:59" || e.fechafin + " 23:59:59",
            user_id: perfil.user_id,
          },
        });
        solicitudes_por_usuario = rpcase;
      }
      let origensolicitudes;
      if (Object.keys(admin).length > 0) {
        origensolicitudes = solicitudes_por_admin;
      } else {    
        const organizacionUsuario = organizaciones.find(
          (org) => org.id_area === idAreaUsuario && org.hd2_type_user === tipoUsuario.type_user
        );
        if (organizacionUsuario) {
            origensolicitudes = solicitudes_por_usuario.filter((item) => {
              const esMismaArea = item.id_area === idAreaUsuario;
              const solicitudNivelesIds = item.id_hd2_organizacion_niveles.split(',').map((id) => parseInt(id.trim()));
              const tieneOrigenValido = solicitudNivelesIds.includes(organizacionUsuario.id);
              return esMismaArea && tieneOrigenValido;
            });
          } else {
            origensolicitudes = [];
          }       
      }

      dispatch(setCasosReporte(origensolicitudes));
      dispatch(setLoadingHD(false));
  };
};

export const getBitacora = (e, niveles) => {
  return async (dispatch, getState) => {
      const xhr = new instanceAxiosPrivate();
      const { data } = await xhr.services.get("/v1/helpdesk/getidcaselog", {
        params: { id: e },
      });
      
      const { data:nivelesDB } = await xhr.services.get("/v1/helpdesk/gethd2levels", {
        params: { ids: niveles}
      });
      
      const infoNivels = nivelesDB.map(r => r.name_organizacion).toString()
      dispatch(setDetallesCaso(data));
      dispatch(setCasoNivelesSelecionado(infoNivels))
      //
      dispatch(setLoadingHD(false));
  };
};


export const getPrioridad = () => {
  return async (dispatch, getState) => {
    const xhr = new instanceAxiosPrivate();
    const { data } = await xhr.services.get("/v1/helpdesk/getprioridad");

    const resp = data.map((d) => ({
        value: d.id,
        label: d.name,
    }))
    dispatch(setPrioridad(resp));
  };
};

export const getUserReasignacionCaso = (e) => {
  return async (dispatch, getState) => {
    const xhr = new instanceAxiosPrivate();
    const { data } = await xhr.services.get("/v1/helpdesk/getuserreasignacioncaso", {
      params: { id: e },
    });

      const resp = data.map((d) => ({
        value: d.user_id,
        label: d.first_name +" " + d.last_name,
    }))

    dispatch(setUserReasignacionCaso(resp));
  };
};



//peticiones para nueva soliucitud
//organizaciones - areas
export const getOrganizacionInicioProceso = () => {
  return async (dispatch, getState) => {
      const xhr = new instanceAxiosPrivate();
      const { data } = await xhr.services.get(
        "/v1/helpdesk/getglosariohd2organizacioninicioproceso"
      );

      let org = data.map((r) => {
        return {
          label: r.name_organizacion,
          value: r.id,
        };
      });
      dispatch(setOrganizaciones(org));
  };
};

export const getDependencias = (idSelected) => {
  return async (dispatch, getState) => {
      const xhr = new instanceAxiosPrivate();
      const { data } = await xhr.services.get(
        "/v1/helpdesk/getglosariohd2organizaciondependencia",
        { params: { organizacion: idSelected } }
      );
      dispatch(setDependencias(data));

      const { matchGA, type_msj } = data;

      const convertToObj = { ...matchGA } || matchGA 

      if (Object.keys(convertToObj).length > 0 ) {
        dispatch(setMatchGA(true));
      } else {
        dispatch(setMatchGA(false));
      }

      if (type_msj) {
        let type = type_msj.map((r) => {
          return {
            label: r.name,
            value: r.id,
          };
        });
        dispatch(setTypeMsj(type));
      }
      return data;
  };
};



export const createFolderHD = () => {
  return async (dispatch, getState) => {
      
      const xhr = new instanceAxiosPrivate();

      const newcase = await  xhr.services.get( `/v1/helpdesk/gethd2casecount`);      
      
      const dataFolder = {
        name: newcase.id,
        parents: ["1bSfG5P-ghTL6_kfTDlgmSM0BOMhhpuuY"]
      }
      //create folder
      const {data} = await xhr.services.post( `/v1/createFolder`, dataFolder);

      if (!data.id) {
        throw new Error("Error al crear folder en drive");        
      }

      return data.id;

  };
};

export const uploadFileDriveHD = (e) => {
  return async (dispatch, getState) => {

      const xhr = new instanceAxiosPrivate();
      const file = xhr.getItemGeneral('evidence');

      const formD = new FormData();          
      formD.append("idFolder", e);
      formD.append("files_drive", file);
      formD.append("parents", e);

      const respUpdFile = await xhr.services.post( `/v1/uploadServer`, formD );      

      return respUpdFile

  };
};

export const saveFiles = () => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoadingHD(true));     
      const xhr = new instanceAxiosPrivate();
      const file = xhr.getItemGeneral('evidence');
     
      const hasFile = file && typeof file === 'object' && file.name;

      if(hasFile) {
        const respNewFolder = await dispatch(createFolderHD())
        const { data } = await dispatch(uploadFileDriveHD(respNewFolder));
        let infDocs = {
          link_evd: data.data.webViewLink,
          idfoldertype: data.idfoldertype
        }   
        await dispatch(updFormInfo(infDocs))      
      }  
      await dispatch(saveCase())  
      dispatch(setLoadingHD(false));    
    } catch (error) {
      dispatch(setLoadingHD(false));   
      toast.error(error.msg || 'Error al guardar archivos');
    }
  };
};

export const saveCase = () => {
  return async (dispatch, getState) => {
    const { formInfo } = getState().helpdesk;        
    const xhr = new instanceAxiosPrivate();
    const { data = {} } = await xhr.services.post(`/v1/helpdesk/addcaso`, formInfo );      
    toast.success(data.msg);
  };
};



export const saveFilesAction = () => {
  return async (dispatch, getState) => {     
    try { 
      dispatch(setLoadingHD(true));        
      const xhr = new instanceAxiosPrivate();
      const file = xhr.getItemGeneral('evidence');

      const hasFile = file && typeof file === 'object' && file.name;
      
      if(hasFile) {
        const respNewFolder = await dispatch(createFolderHD())
        const { data } = await dispatch(uploadFileDriveHD(respNewFolder));
        let infDocs = {
          link_evd: data.data.webViewLink,
          idfoldertype: data.idfoldertype
        }   
        await dispatch(updFormInfo(infDocs))      
      } 
      await dispatch(saveCaseAction())    
      dispatch(setLoadingHD(false));
    } catch (error) {
      dispatch(setLoadingHD(false));
      toast.error(error.msg);
    }
  };
};


export const saveCaseAction = () => {
  return async (dispatch, getState) => {
      const { formInfo } = getState().helpdesk;        
      const xhr = new instanceAxiosPrivate();
      if (formInfo.type === 'POST') {
        const { data = {} } = await xhr.services.post(formInfo.url, formInfo ); 
        toast.success(data.msg);
      } else {
        const { data = {} } = await xhr.services.put(formInfo.url, formInfo ); 
        toast.success(data.msg);
      }
      await dispatch(getUserSolicitudes())
      await dispatch(getReporteSolicitudes())
  };
};


export const downloadFile = (e) => {
  return async (dispatch, getState) => {
      const xhr = new instanceAxiosPrivate();
      const { data } = await xhr.services.get(
        "/v1/previewFile",
        { params: { parents: e } }
      );

      let link = document.createElement('a');
      link.href = data.content;
      link.target = "_blank";
      link.click();     
  };
}
